var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconTreeCollapse = function SvgIconTreeCollapse(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    strokeWidth: 0
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m11.41 8-6-6L4 3.41 8.58 8 4 12.59 5.41 14Z",
    fill: "#a1a1a1"
  })));
};
export { SvgIconTreeCollapse as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAxNiAxNiIgc3Ryb2tlLXdpZHRoPSIwIj4KICAgIDxwYXRoIGQ9Ik02LDAsMCw2LDEuNDEsNy40MSw2LDIuODNsNC41OSw0LjU4TDEyLDZaIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgxMS40MSAyKSByb3RhdGUoOTApIiBmaWxsPSIjYTFhMWExIi8+Cjwvc3ZnPgo=";